import * as React from 'react';
import { connect } from 'react-redux';
import INotesAppState from './interfaces/notesAppState';
import IExportModal from './interfaces/exportModal';
import { actionCreators } from './redux/actions';
import { NotePackageService } from '../../services/notePackageService';
import { createPortal } from 'react-dom';

class ExportModal extends React.Component<IExportModal, null> {
    render() {
        return (
            createPortal(
                <React.Fragment>
                    {
                        this.props.displayExportModal || this.props.displayShareModal
                            ?
                            <div className="modal--open modal-export-notes" onClick={(event) => event.stopPropagation()}>
                                <div className="modal__overlay">
                                    <div className="modal__window">
                                        <button className="modal__close" onClick={(event) => {
                                            if (this.props.displayExportModal) {
                                                this.props.toggleExportModal(event)
                                            }
                                            if (this.props.displayShareModal) {
                                                this.props.toggleShareModal(event)
                                            }
                                        }}>Stäng</button>
                                        <form name="form">
                                            {
                                                this.props.displayExportModal
                                                    ? (
                                                        <div className="modal-export-notes__view">
                                                            <div className="modal__content">
                                                                <h2 className="modal__title">Exportera anteckningar</h2>
                                                                <label htmlFor="bookmarks-export-name">Namn för exporten:</label>
                                                                <input type="text" name="name" onChange={(event) => { this.props.setEditedExportName(event, this.props.buttonIsDisabled) }} defaultValue={this.props.editedExportName} />
                                                                <p>I nästa steg kommer du få möjlighet att dela markerade anteckningar.</p>

                                                            <div className="modalCTAs">
                                                                <button className="genericBtn alternate" onClick={(event) => {
                                                                    this.props.toggleExportModal(event)
                                                                }}>Avbryt</button>
                                                                <button className="genericBtn primary" disabled={this.props.buttonIsDisabled} onClick={(event) => {
                                                                    this.props.createExport(event, this.props.editedExportName, this.props.selectedNotes)
                                                                }}>Exportera</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                    : null
                                            }
                                            {
                                                this.props.displayShareModal
                                                    ? (
                                                        <div className="modal-export-notes__view">
                                                            <div className="modal__content">
                                                                <h2 className="modal__title">Dela anteckningar</h2>
                                                                <p>Kopiera länk och dela med andra användare:</p>
                                                                <input type="text" name="url" defaultValue={this.props.shareUrl} />
                                                                <p>Dela via e-post genom att fylla i en eller flera mottagare (separera med kommatecken):</p>
                                                                <input type="text" name="mail" defaultValue={this.props.emailsToShareTo} onChange={(event) => {
                                                                    this.props.setEmailsToShareTo(event);
                                                                }} />

                                                                <div className="modalCTAs">
                                                                    <button className="genericBtn alternate" onClick={(event) => {
                                                                        this.props.toggleShareModal(event)
                                                                    }}>Avbryt</button>
                                                                    <button className="genericBtn primary" onClick={(event) => {
                                                                        this.props.sendToEmails(event, this.props.emailsToShareTo, this.props.shareUrl)
                                                                    }}>Skicka</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                    : null
                                            }
                                        </form>
                                    </div>
                                </div>
                            </div>
                            : null
                    }
                </React.Fragment>,
                document.body)
        );
    }
}

const mapDispatchToProps = (dispatch, ownProps): IExportModal => {
    const notePackageService = new NotePackageService();

    return {
        ...ownProps,
        setEmailsToShareTo: (event) => {
            if (event) {
                dispatch(actionCreators.setEmailsToShareTo(event.target.value))
            }
        },
        sendToEmails: (event, listOfEmails: string, url: string) => {
            if (event) {
                event.preventDefault()
            }
            if (listOfEmails && url) {
                const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                const emails = listOfEmails
                    .split(',')
                    .map((email) => email.trim())
                    .filter((email) => emailRegex.test(email));
                const extractQueryKeyValue = (url: string, key: string): string => {
                    const queries = url.slice(url.indexOf('?') + 1).split('&');

                    for (const query of queries) {
                        const splitQuery = query.split('=');
                        if (splitQuery[0] === key) {
                            return splitQuery[1];
                        }
                    }

                    return undefined;
                }
                const id = extractQueryKeyValue(url, 'share')

                if (!id.length || !emails.length) {
                    return;
                }
                notePackageService.emailExportedNotes(
                    id,
                    emails,
                    () => {
                        dispatch(actionCreators.toggleShareModal())
                        dispatch(actionCreators.setEmailsToShareTo(event.target.value))
                        dispatch(actionCreators.setToastBarType('success'));
                        dispatch(actionCreators.setToastBarMessage('Exporten sparades'));
                    },
                    () => {
                        dispatch(actionCreators.toggleShareModal())
                        dispatch(actionCreators.setEmailsToShareTo(event.target.value))
                        dispatch(actionCreators.setToastBarType('warn'));
                        dispatch(actionCreators.setToastBarMessage('Tillfälligt fel: Kan inte skicka exporterade anteckningar'));
                    }
                );
            }
        },
        toggleExportModal: (event) => {
            if (event) {
                event.preventDefault();
            }
            dispatch(actionCreators.toggleExportModal());
            dispatch(actionCreators.setExportName(''));
        },
        toggleShareModal: (event) => {
            if (event) {
                event.preventDefault();
            }
            dispatch(actionCreators.toggleShareModal());
            dispatch(actionCreators.setShareUrl(''));
        },
        createExport: (event, exportName: string, selectedNotes) => {
            event.preventDefault();
            if (exportName && selectedNotes) {
                if (selectedNotes) {
                    notePackageService.exportNotes(exportName, selectedNotes, (data) => {
                        dispatch(actionCreators.toggleExportModal());
                        dispatch(actionCreators.setShareUrl(data.shareUrl))
                        dispatch(actionCreators.toggleShareModal());
                    }, (err) => {
                        console.error('error', err)
                    })
                }
            }
        },
        setEditedExportName: (event, buttonIsDisabled) => {
            event.preventDefault();
            if (buttonIsDisabled) {
                dispatch(actionCreators.toggleExportModalButton());
            }
            dispatch(actionCreators.setExportName(event.target.value))
        }
    };
}

const mapStateToProps = (state: INotesAppState): IExportModal => {
    return { displayExportModal: state.displayExportModal, displayShareModal: state.displayShareModal, editedExportName: state.editedExportName, selectedNotes: state.selectedNotes, shareUrl: state.shareUrl, emailsToShareTo: state.emailsToShareTo, buttonIsDisabled: state.exportModalButtonIsDisabled };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExportModal);